var _defs, _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropship3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4a00e8;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 4px;\n      }\n\n      .cls-2 {\n        fill: #e0ef4d;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 55.15,
    y: 61.54,
    width: 189.69,
    height: 182.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.15,109.87h0c-8.73,0-15.81-7.08-15.81-15.81v-12.88h31.62v12.88c0,8.73-7.08,15.81-15.81,15.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M86.77,109.87h0c-8.73,0-15.81-7.08-15.81-15.81v-12.88h31.62v12.88c0,8.73-7.08,15.81-15.81,15.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M118.38,109.87h0c-8.73,0-15.81-7.08-15.81-15.81v-12.88h31.62v12.88c0,8.73-7.08,15.81-15.81,15.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M150,109.87h0c-8.73,0-15.81-7.08-15.81-15.81v-12.88h31.62v12.88c0,8.73-7.08,15.81-15.81,15.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M181.62,109.87h0c-8.73,0-15.81-7.08-15.81-15.81v-12.88h31.62v12.88c0,8.73-7.08,15.81-15.81,15.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M213.23,109.87h0c-8.73,0-15.81-7.08-15.81-15.81v-12.88h31.62v12.88c0,8.73-7.08,15.81-15.81,15.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M244.85,109.87h0c-8.73,0-15.81-7.08-15.81-15.81v-12.88h31.62v12.88c0,8.73-7.08,15.81-15.81,15.81Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "70.96 81.18 39.35 81.18 56.48 51.09 81.77 51.09 70.96 81.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "102.58 81.18 70.96 81.18 81.77 51.09 109.06 51.09 102.58 81.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "134.19 81.18 102.58 81.18 109.06 51.09 136.35 51.09 134.19 81.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "165.81 81.18 134.19 81.18 136.35 51.09 163.65 51.09 165.81 81.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "197.42 81.18 165.81 81.18 163.65 51.09 190.94 51.09 197.42 81.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "229.04 81.18 197.42 81.18 190.94 51.09 218.23 51.09 229.04 81.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "260.65 81.18 229.04 81.18 218.23 51.09 243.52 51.09 260.65 81.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M253.61,229.06H46.39c-3.99,0-7.22,3.23-7.22,7.22v10.58c0,1.13,.92,2.05,2.05,2.05h217.56c1.13,0,2.05-.92,2.05-2.05v-10.58c0-3.99-3.23-7.22-7.22-7.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M231.92,229.06H67.82V125.39c0-1.59,1.29-2.88,2.88-2.88H229.04c1.59,0,2.88,1.29,2.88,2.88v103.67h0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M189.03,199.04s6.54-2.62,13.25-1.43c6.71,1.18,10.21,4.3,10.21,4.3l-17.17,7.05-6.29-9.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M79.91,213.4v13.24c0,1.28,1.04,2.32,2.32,2.32h79.2s12.16,.55,37.75-5.7c9.86-2.41,18.41-6.32,20.84-9.44,0,0,1.18-9.02-6.86-13.39l-14.91,4.11-50.3,3.73-54.43,3.11-11.23-.3c-1.31-.03-2.39,1.02-2.39,2.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123.35,154.58s-4.88-7.32-7.53-7.3-6.43,5.78-7.58,9.55l15.11-2.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.02,156.14c-1.19-.07-2.08,1.09-1.69,2.22,.77,2.2,1.79,5.45,2.01,7.73,.36,3.77,.58,9.27-1.74,15.14-2.32,5.87-6.45,24.41-4.78,29.84,0,0,72.08,.53,78.55,.21s32.37-3.82,37.88-6.73c0,0-2.33-6.02-16.77-9.26-14.44-3.24-21.89-4.81-29.91-12.27-7.62-7.08-18.06-19.33-22.66-28.89-.42-.86-1.37-1.32-2.31-1.13-5.15,1.08-21.72,4.18-38.58,3.15Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 109.03,
    cy: 178.69,
    r: 12.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M108.75,182.63l-2.17,.77c-.55,.2-1.13-.22-1.12-.81l.06-2.3c0-.19-.06-.38-.17-.53l-1.4-1.82c-.36-.47-.14-1.15,.43-1.31l2.21-.65c.18-.05,.34-.17,.45-.33l1.3-1.9c.33-.48,1.05-.48,1.38,0l1.3,1.9c.11,.16,.27,.28,.45,.33l2.21,.65c.56,.17,.79,.85,.43,1.31l-1.4,1.82c-.12,.15-.18,.34-.17,.53l.06,2.3c.02,.59-.56,1.01-1.12,.81l-2.17-.77c-.18-.06-.38-.06-.56,0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 125.69,
    y1: 163.76,
    x2: 134.65,
    y2: 159.73
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M125.69,165.54c-.68,0-1.33-.39-1.63-1.05-.4-.9,0-1.95,.89-2.36l8.96-4.03c.9-.41,1.95,0,2.36,.89,.4,.9,0,1.95-.89,2.36l-8.96,4.03c-.24,.11-.49,.16-.73,.16Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 137.42,
    y1: 179.85,
    x2: 145.35,
    y2: 174.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M137.42,181.64c-.55,0-1.09-.25-1.44-.73-.58-.79-.41-1.91,.39-2.49l7.93-5.81c.79-.58,1.91-.41,2.49,.38,.58,.79,.41,1.91-.39,2.49l-7.93,5.81c-.32,.23-.69,.34-1.05,.34Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 172.53,
    y1: 201.18,
    x2: 177.81,
    y2: 192.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M172.53,202.96c-.33,0-.66-.09-.95-.28-.83-.53-1.08-1.63-.55-2.46l5.27-8.3c.53-.83,1.63-1.07,2.46-.55,.83,.53,1.08,1.63,.55,2.46l-5.27,8.3c-.34,.53-.92,.83-1.51,.83Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 151.98,
    y1: 192.85,
    x2: 158.93,
    y2: 185.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M151.98,194.63c-.46,0-.91-.17-1.26-.52-.7-.7-.7-1.82,0-2.52l6.95-6.95c.7-.7,1.83-.7,2.52,0,.7,.7,.7,1.82,0,2.52l-6.95,6.95c-.35,.35-.8,.52-1.26,.52Z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M228.51,83.62c-23.17,.28-42.2,19.31-42.49,42.48-.11,8.79,2.43,16.98,6.86,23.84l-1.84,11.77c-.31,2.01,1.42,3.74,3.43,3.43l11.99-1.88c6.83,4.22,14.92,6.59,23.58,6.4,22.98-.52,41.73-19.47,42.02-42.45,.31-24.19-19.36-43.87-43.55-43.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M216.42,129.72h5.54v23.32c0,2.16,1.75,3.91,3.91,3.91s3.91-1.75,3.91-3.91v-23.32h6.04c2.16,0,3.91-1.75,3.91-3.91s-1.75-3.91-3.91-3.91h-6.04v-10.94c0-3.76,3.06-6.81,6.82-6.81h5.06c2.16,0,3.91-1.75,3.91-3.91s-1.75-3.91-3.91-3.91h-5.06c-8.07,0-14.64,6.57-14.64,14.64v10.94h-5.54c-2.16,0-3.91,1.75-3.91,3.91s1.75,3.91,3.91,3.91Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M27.94,87.64c.28,23.17,19.31,42.2,42.48,42.49,8.79,.11,16.98-2.43,23.84-6.86l11.77,1.84c2.01,.31,3.74-1.42,3.43-3.43l-1.88-11.99c4.22-6.83,6.59-14.92,6.4-23.58-.52-22.98-19.47-41.73-42.45-42.02-24.19-.31-43.87,19.36-43.58,43.55Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 46.61,
    y: 62.75,
    width: 48.71,
    height: 48.71,
    rx: 9.35,
    ry: 9.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 70.96,
    cy: 87.11,
    r: 11.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 85.92,
    cy: 72.15,
    r: 2.66
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropship3);
export default __webpack_public_path__ + "static/media/dropship_3.207449a2b518a77342f211d8dfe02b6a.svg";
export { ForwardRef as ReactComponent };